import React from "react"
import Carousel from "react-multi-carousel"
import clsx from "clsx"

import { Container, FlexBox } from "@components/wrapper"
import { Course } from "@interfaces/course"
import { slider_column } from "@constants/styles"
import { ClassCard, LoadingClassCard } from "@components/card"
import { SliderArrow } from "@components/slider"
import { Heading } from "@components/typography"

interface ClassRowProps {
  title: string
  screenWidth: number
  isLoading: boolean
  data: Course[]
}

export const ClassRow: React.FC<ClassRowProps> = ({ title, screenWidth, isLoading, data }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const Component = () => {
    switch (true) {
      case screenWidth > 576 && isLoading: {
        return (
          <FlexBox justify="between">
            {[1, 2, 3, 4].map((value) => (
              <LoadingClassCard key={value} className="w-[23%]" />
            ))}
          </FlexBox>
        )
      }

      case screenWidth < 576 && isLoading: {
        return (
          <div className={clsx(slider_column, "pb-5")}>
            <div className="w-fit flex py-0 px-[15px]">
              {[1, 2, 3].map((value) => (
                <LoadingClassCard key={value} className="mr-[4vw] w-[65vw]" />
              ))}
            </div>
          </div>
        )
      }

      case screenWidth > 576 && !isLoading: {
        return (
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            arrows={false}
            renderButtonGroupOutside
            className="ml-[-2vw]"
            customButtonGroup={<SliderArrow length={data.length} displayedSlide={4} />}
            itemClass="pl-[2vw]"
          >
            {data.map((value, index) => (
              <ClassCard key={index} data={value} />
            ))}
          </Carousel>
        )
      }

      case screenWidth < 576 && !isLoading: {
        return (
          <div className={clsx(slider_column, "pb-5")}>
            <div className="w-fit flex py-0 px-[15px]">
              {data.map((value, index) => (
                <ClassCard key={index} data={value} className="mr-[4vw] w-[65vw]" />
              ))}
            </div>
          </div>
        )
      }
      default:
        return <></>
    }
  }

  if (!isLoading && !data.length) {
    return <></>
  }

  return (
    <section>
      <Container className={clsx("sm:py-[50px] relative", "pt-2")}>
        <Heading headingLevel="h2" className={clsx("sm:mb-10", "mb-3")}>
          {title}
        </Heading>

        <Component />
      </Container>
    </section>
  )
}
